export default __webpack_public_path__ + "static/media/Kidneys.839eff72.svg";